/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import { LoaderWrap } from "~/components";
import { useGetProviderAccountsCount } from "~/layout/MenuBar/submenus";
import { AccessHandler } from "~/routing/utils";

export function ReservationsCommitmentsAccessHandler({
  accessTo,
  children,
}: PropsWithChildren<{
  accessTo: "aws" | "azure";
}>) {
  const { hasAWS, hasAzure, loading } = useGetProviderAccountsCount();

  const hasAccess = {
    aws: hasAWS,
    azure: hasAzure,
  }[accessTo];

  return (
    <LoaderWrap loading={loading}>
      <AccessHandler hasAccess={hasAccess}>
        <>{children}</>
      </AccessHandler>
    </LoaderWrap>
  );
}
